"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RWSToolsAskForVoucherDataComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="rws-tools-ask-for-voucher-data">
    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.voucherData) === null || _a === void 0 ? void 0 : _a.detected; }, (0, fast_element_1.html) `
        <div class="voucher-detected">
            <span class="voucher-icon">🎟️</span>
            <span class="voucher-text">${'askForVoucher.detected'.t()}</span>
        </div>
    `)}

    ${(0, fast_element_1.when)(x => { var _a; return !((_a = x.voucherData) === null || _a === void 0 ? void 0 : _a.detected); }, (0, fast_element_1.html) `
        <div class="empty-state">
            <span class="empty-icon">🎟️</span>
            <p>${'askForVoucher.notDetected'.t()}</p>
        </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rws-tools-ask-for-voucher-data {
  border-radius: 12px;
}
.rws-tools-ask-for-voucher-data .voucher-detected {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: var(--success-color-light, #d4edda);
  border: 1px solid var(--success-color, #28a745);
  border-radius: 8px;
}
.rws-tools-ask-for-voucher-data .voucher-detected .voucher-icon {
  font-size: 1.5rem;
}
.rws-tools-ask-for-voucher-data .voucher-detected .voucher-text {
  font-weight: 600;
  color: var(--success-color-dark, #155724);
  font-size: 0.95rem;
}
.rws-tools-ask-for-voucher-data .empty-state {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-ask-for-voucher-data .empty-state .empty-icon {
  font-size: 3rem;
  margin-bottom: 16px;
  display: block;
  opacity: 0.7;
}
.rws-tools-ask-for-voucher-data .empty-state p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}
.rws-tools-ask-for-voucher-data .empty-state .empty-suggestion {
  color: var(--text-tertiary, #9ca3af);
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 8px;
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-container {
  background: var(--bg-secondary-dark, #2d3748);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-list-item {
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-list-item .item-title {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-list-item .item-subtitle {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-list-item .item-description {
  color: var(--text-secondary-dark, #a0aec0);
  border-top-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-list-item:hover {
  background: var(--bg-hover-dark, #4a5568);
  border-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-list-item:hover::after {
  background: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-query-display {
  background: var(--bg-secondary-dark, #2d3748);
  border-left-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-query-display .query-label {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-query-display .query-text {
  color: var(--text-primary-dark, #f7fafc);
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-results-summary {
  background: var(--success-color-dark-bg, #1e4d2b);
  border-color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-results-summary .results-count {
  color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-empty-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-empty-state p {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-empty-state .empty-suggestion {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-loading-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-ask-for-voucher-data .tool-loading-state .spinner {
  border-color: var(--border-color-dark, #4a5568);
  border-top-color: var(--primary-color-dark, #63b3ed);
}
@media (max-width: 768px) {
  .rws-tools-ask-for-voucher-data {
    padding: 16px;
    margin: 12px 0;
  }
  .rws-tools-ask-for-voucher-data h3 {
    font-size: 1.1rem;
  }
  .rws-tools-ask-for-voucher-data h4 {
    font-size: 0.95rem;
  }
  .rws-tools-ask-for-voucher-data .tool-container {
    padding: 12px;
  }
  .rws-tools-ask-for-voucher-data .tool-list-item {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .rws-tools-ask-for-voucher-data .tool-list-item .item-title {
    font-size: 0.9rem;
  }
  .rws-tools-ask-for-voucher-data .tool-list-item .item-description {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .rws-tools-ask-for-voucher-data .tool-empty-state {
    padding: 24px 12px;
  }
  .rws-tools-ask-for-voucher-data .tool-empty-state .empty-icon {
    font-size: 2rem;
  }
  .rws-tools-ask-for-voucher-data .tool-empty-state p {
    font-size: 0.9rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let RWSToolsAskForVoucherDataComponent = class RWSToolsAskForVoucherDataComponent extends client_1.RWSViewComponent {
};
exports.RWSToolsAskForVoucherDataComponent = RWSToolsAskForVoucherDataComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], RWSToolsAskForVoucherDataComponent.prototype, "voucherData", void 0);
exports.RWSToolsAskForVoucherDataComponent = RWSToolsAskForVoucherDataComponent = __decorate([
    (0, client_1.RWSView)('rws-tools-ask-for-voucher-data', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RWSToolsAskForVoucherDataComponent);
RWSToolsAskForVoucherDataComponent.defineComponent();
